import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { isMobile } from './style';

const Footer: React.FC = () => {
  return (
    <Footers>
      <Nav>
        <NavLinks
          className={({ isActive }) => (isActive ? 'active' : '')}
          to="/"
        >
          주제
        </NavLinks>
      </Nav>
      <Nav>
        <NavLinks
          className={({ isActive }) => (isActive ? 'active' : '')}
          to="/debate"
        >
          토론
        </NavLinks>
      </Nav>
      <Nav>
        <NavLinks
          className={({ isActive }) => (isActive ? 'active' : '')}
          to="/dev"
        >
          개발자
        </NavLinks>
      </Nav>
    </Footers>
  );
};

export default Footer;

const Footers = styled.div`
  background: #c4e0d6;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 95px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  ${isMobile} {
    height: 70px;
  }
`;

const Nav = styled.div`
  border-right: 1px solid rgba(167, 202, 189, 0.8);
`;

const NavLinks = styled(NavLink)`
  color: #8c9f96;
  font-family: 'GmarketSansBold';
  font-size: 23px;
  font-weight: 700;
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  &:hover {
    color: #566d62;
  }

  &.active {
    color: #566d62;
  }

  ${isMobile} {
    font-size: 18px;
  }
`;
